import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

// Academic Years
export const fetchAcademicYears = async (activeOnly = false) => {
  const url = activeOnly ? `${API_BASE_URL}/academic-years?active_only=true` : `${API_BASE_URL}/academic-years`;
  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createAcademicYear = async (data) => {
  const response = await fetch(`${API_BASE_URL}/academic-years`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateAcademicYear = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/academic-years/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteAcademicYear = async (id) => {
  const response = await fetch(`${API_BASE_URL}/academic-years/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

// Standards
export const fetchStandards = async (academicYearId, clusterId) => {
  let url = `${API_BASE_URL}/standards`;
  const params = [];
  if (typeof academicYearId === 'object' && academicYearId !== null) {
    if (academicYearId.academic_year_id) params.push(`academic_year_id=${academicYearId.academic_year_id}`);
    if (academicYearId.cluster_id) params.push(`cluster_id=${academicYearId.cluster_id}`);
  } else {
    if (academicYearId) params.push(`academic_year_id=${academicYearId}`);
    if (clusterId) params.push(`cluster_id=${clusterId}`);
  }
  if (params.length > 0) url += `?${params.join('&')}`;
  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createStandard = async (data) => {
  const response = await fetch(`${API_BASE_URL}/standards`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateStandard = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/standards/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteStandard = async (id) => {
  const response = await fetch(`${API_BASE_URL}/standards/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const copyStandardsToAcademicYear = async (data) => {
  const response = await fetch(`${API_BASE_URL}/standards/copy`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

// Subjects
export const fetchSubjects = async (standardId, academicYearId) => {
  let url = `${API_BASE_URL}/subjects`;
  const params = [];
  if (standardId) params.push(`standard_id=${standardId}`);
  if (academicYearId) params.push(`academic_year_id=${academicYearId}`);
  if (params.length > 0) url += `?${params.join('&')}`;

  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createSubject = async (data) => {
  const response = await fetch(`${API_BASE_URL}/subjects`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateSubject = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/subjects/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteSubject = async (id) => {
  const response = await fetch(`${API_BASE_URL}/subjects/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const bulkUploadSubjects = async (data) => {
  const response = await fetch(`${API_BASE_URL}/subjects/bulk`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

// Lessons
export const fetchLessons = async (standardId, subjectsId, academicYearId) => {
  let url = `${API_BASE_URL}/lessons`;
  const params = [];
  if (standardId) params.push(`standard_id=${standardId}`);
  if (subjectsId) params.push(`subjects_id=${subjectsId}`);
  if (academicYearId) params.push(`academic_year_id=${academicYearId}`);
  if (params.length > 0) url += `?${params.join('&')}`;

  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createLesson = async (data) => {
  const response = await fetch(`${API_BASE_URL}/lessons`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateLesson = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/lessons/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteLesson = async (id) => {
  const response = await fetch(`${API_BASE_URL}/lessons/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const bulkUploadLessons = async (data) => {
  const response = await fetch(`${API_BASE_URL}/lessons/bulk`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

// Daily Sessions
export const fetchDailySessions = async (filters = {}) => {
  let url = `${API_BASE_URL}/daily-sessions`;
  const params = [];
  if (filters.cluster_id) params.push(`cluster_id=${filters.cluster_id}`);
  if (filters.academic_year_id) params.push(`academic_year_id=${filters.academic_year_id}`);
  if (filters.daily_session_date) params.push(`daily_session_date=${filters.daily_session_date}`);
  if (filters.instructor_id) params.push(`instructor_id=${filters.instructor_id}`);
  if (filters.standard_id) params.push(`standard_id=${filters.standard_id}`);
  if (filters.subjects_id) params.push(`subjects_id=${filters.subjects_id}`);
  if (filters.lessons_id) params.push(`lessons_id=${filters.lessons_id}`);

  if (params.length > 0) url += `?${params.join('&')}`;

  const response = await fetch(url, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createDailySession = async (data) => {
  const response = await fetch(`${API_BASE_URL}/daily-sessions`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateDailySession = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/daily-sessions/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteDailySession = async (id) => {
  const response = await fetch(`${API_BASE_URL}/daily-sessions/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const bulkUploadDailySessions = async (data) => {
  const response = await fetch(`${API_BASE_URL}/daily-sessions/bulk-upload`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};
